module.exports = __webpack_public_path__ + "img/bb_g3_t_eyes-04.a5a2a7e4.svg";